import script from "./UcapanDoa.vue?vue&type=script&setup=true&lang=js"
export * from "./UcapanDoa.vue?vue&type=script&setup=true&lang=js"

import "./UcapanDoa.vue?vue&type=style&index=0&id=0ac06810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac06810"]])

export default __exports__